// import React, { useState } from 'react';
// import { Layout, Typography } from 'antd';
// import {
//   DashboardOutlined, ProjectOutlined, CodeOutlined,
//   HistoryOutlined, UserOutlined, SafetyCertificateOutlined,
//   MailOutlined,
// } from '@ant-design/icons';

// import LoginPage       from './pages/LoginPage';
// import Navbar          from './components/Navbar';
// import OverviewPage    from './pages/OverviewPage';
// import ProjectsPage    from './pages/ProjectsPage';
// import SkillsPage      from './pages/SkillsPage';
// import ExperiencePage  from './pages/ExperiencePage';
// import AboutPage       from './pages/AboutPage';
// import CertificatesPage from './pages/CertificatesPage';
// import AdminDashboard  from './pages/AdminDashboard';
// import SupabaseImageUploader from './pages/img';
// import ImageControlPage from './pages/Imagecontrolpage';
// import HeroControlPage from './pages/Herocontrolpage';

// const { Content } = Layout;

// const PAGES = {
//   overview:     { label: 'Overview',      component: <OverviewPage /> },
//   about:        { label: 'About',         component: <AboutPage /> },
//   projects:     { label: 'Projects',      component: <ProjectsPage /> },
//   skills:       { label: 'Skills',        component: <SkillsPage /> },
//   experience:   { label: 'Experience',    component: <ExperiencePage /> },
//   certificates: { label: 'Certificates', component: <CertificatesPage /> },
//   admin:        { label: 'Admin Panel',   component: <AdminDashboard /> },
//   image:   { label: 'image uploader',   component: <SupabaseImageUploader /> },
//     philosophy:   { label: 'philosophy',   component: <ImageControlPage /> },
//         HeroControlPage:   { label: 'HeroControlPage',   component: <HeroControlPage /> },



// };

// /* Inject global mobile-responsive base styles once */
// if (typeof document !== 'undefined') {
//   const id = 'portfolio-global-styles';
//   if (!document.getElementById(id)) {
//     const s = document.createElement('style');
//     s.id = id;
//     document.head.appendChild(s);
//   }
// }

// export default function App() {
//   const [loggedIn,  setLoggedIn]  = useState(false);
//   const [username,  setUsername]  = useState('');
//   const [current,   setCurrent]   = useState('overview');

//   const handleLogin  = (name) => { setUsername(name); setLoggedIn(true); };
//   const handleLogout = ()     => { setLoggedIn(false); setUsername(''); setCurrent('overview'); };

//   if (!loggedIn) {
//     return <LoginPage onLogin={handleLogin} />;
//   }

//   return (
//     <Layout style={{ minHeight: '100vh', background: 'white' }}>
//       {/* ── Top Navbar (always visible) ── */}
//       <Navbar
//         current={current}
//         onNavigate={setCurrent}
//         onLogout={handleLogout}
//         username={username}
//       />

//       {/* ── Main Content ── */}
//       <Content
//         style={{
//           margin: '0 auto',
//           width: '100%',
//           maxWidth: '1280px',
//           padding: '24px 20px',
//           boxSizing: 'border-box',
//         }}
//       >
//         <div style={{
//           padding: '24px',
//           minHeight: 'calc(100vh - 112px)',
//         }}>
//           {/* Page Title */}

//           {/* Active Page */}
//           {PAGES[current]?.component}
//         </div>
//       </Content>
//     </Layout>
//   );
// }
import React, { useEffect, useState } from 'react';
import { Layout } from 'antd';
import LoginPage from './pages/LoginPage';
import Navbar from './components/Navbar';
import OverviewPage from './pages/OverviewPage';
import ProjectsPage from './pages/ProjectsPage';
import SkillsPage from './pages/SkillsPage';
import ExperiencePage from './pages/ExperiencePage';
import AboutPage from './pages/AboutPage';
import CertificatesPage from './pages/CertificatesPage';
import AdminDashboard from './pages/AdminDashboard';
import SupabaseImageUploader from './pages/img';
import ImageControlPage from './pages/Imagecontrolpage';
import HeroControlPage from './pages/Herocontrolpage';
import ThemePage from './pages/Themepage';
import BlogPage from './pages/Blogpage';
import AuthorsList from './pagescopy/AuthorsList';
import Dashboard from './pagescopy/Dashboard';
import PostsList from './pagescopy/PostsList';
import SiteSettings from './pagescopy/SiteSettings';
import PostForm from './pagescopy/PostForm';

const { Content } = Layout;

export default function App() {
  const [loggedIn, setLoggedIn] = useState(false);
  const [username, setUsername] = useState('');
  const [current, setCurrent] = useState('overview');
  const [editingPostId, setEditingPostId] = useState(null);

  const openNewPost = () => {
    setEditingPostId(null);
    setCurrent('PostForm');
  };

  const openEditPost = (record) => {
    setEditingPostId(record.id);
    setCurrent('PostForm');
  };

  const closePostForm = () => {
    setEditingPostId(null);
    setCurrent('PostsList');
  };

  // PAGES is defined inside App so it can pass state/callbacks down as props
  const PAGES = {
    overview: { label: 'Overview', component: <OverviewPage /> },
    about: { label: 'About', component: <AboutPage /> },
    projects: { label: 'Projects', component: <ProjectsPage /> },
    skills: { label: 'Skills', component: <SkillsPage /> },
    experience: { label: 'Experience', component: <ExperiencePage /> },
    certificates: { label: 'Certificates', component: <CertificatesPage /> },
    admin: { label: 'Admin Panel', component: <AdminDashboard /> },
    image: { label: 'image uploader', component: <SupabaseImageUploader /> },
    philosophy: { label: 'philosophy', component: <ImageControlPage /> },
    HeroControlPage: { label: 'HeroControlPage', component: <HeroControlPage /> },
    ThemePage: { label: 'ThemePage', component: <ThemePage /> },
    BlogPage: { label: 'BlogPage', component: <BlogPage onNavigate={setCurrent} /> },
    AuthorsList: { label: 'AuthorsList', component: <AuthorsList onNavigate={setCurrent} /> },
    Dashboard: { label: 'Dashboard', component: <Dashboard onNavigate={setCurrent} /> },
    PostsList: {
      label: 'PostsList',
      component: <PostsList onEditPost={openEditPost} onNewPost={openNewPost} />,
    },
    SiteSettings: { label: 'SiteSettings', component: <SiteSettings onNavigate={setCurrent} /> },
    PostForm: {
      label: 'PostForm',
      component: <PostForm postId={editingPostId} onDone={closePostForm} onCancel={closePostForm} />,
    },
  };

  // On refresh: if creds exist in localStorage, stay logged in
  useEffect(() => {
    const storedUsername = localStorage.getItem('auth_username');
    const storedPassword = localStorage.getItem('auth_password');
    if (storedUsername && storedPassword) {
      setUsername(storedUsername);
      setLoggedIn(true);
    }
  }, []);

  const handleLogin = (name) => {
    setUsername(name);
    setLoggedIn(true);
    setCurrent('overview');
  };

  const handleLogout = () => {
    localStorage.removeItem('auth_username');
    localStorage.removeItem('auth_password');
    setLoggedIn(false);
    setUsername('');
    setCurrent('overview');
  };

  if (!loggedIn) {
    return <LoginPage onLogin={handleLogin} />;
  }

  return (
    <Layout style={{ minHeight: '100vh', background: 'white' }}>
      <Navbar
        current={current}
        onNavigate={setCurrent}
        onLogout={handleLogout}
        username={username}
      />
      <Content
        style={{
          margin: '0 auto',
          width: '100%',
          maxWidth: '1280px',
          padding: '24px 20px',
          boxSizing: 'border-box',
        }}
      >
        <div style={{ padding: '24px', minHeight: 'calc(100vh - 112px)' }}>
          {PAGES[current]?.component}
        </div>
      </Content>
    </Layout>
  );
}